import { PreloadAllModules, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { DashboardComponent } from "./screens/dashboard/dashboard.component";
import { AppMainComponent } from "./app.main.component";
import { LoginComponent } from "./screens/login/login.component";
import { TokenGuard } from "./core/services/token.guard";
import { MyDataComponent } from "./screens/my-data/my-data.component";
import { UsersComponent } from "./screens/users/users.component";
import { LocationStrategy, PathLocationStrategy } from "@angular/common";
import { InvestmentsComponent } from "./screens/investments/investments.component";
import { TransactionsComponent } from "./screens/transactions/transactions.component";
import { InvestmentsUserComponent } from "./screens/investments-user/investments-user.component";
import { PrivacyPolicyComponent } from "./screens/privacy-policy/privacy-policy.component";
import { ConditionsGeneralComponent } from "./screens/conditions-general/conditions-generalcomponent";
import { ImportComponent } from "./screens/import/import.component";
import { GraphicsComponent } from "./screens/graphics/graphics.component";

@NgModule({
	imports: [
		RouterModule.forRoot(
			[
				{ 
					path: "", 
					redirectTo: "login", 
					pathMatch: "full"
				},
				{ 
					path: "privacy-policy", 
					component: PrivacyPolicyComponent
				},
				{ 
					path: "conditions-general", 
					component: ConditionsGeneralComponent
				},
				{ 
					path: "login", 
					component: LoginComponent
				},
				{
					path: "app",
					component: AppMainComponent,
					canActivate: [TokenGuard],
					children: [
						{
							path: "",
							component: DashboardComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "import",
							component: ImportComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "graphics",
							component: GraphicsComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "my-data",
							component: MyDataComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "users",
							component: UsersComponent,
							canActivate: [TokenGuard],
						},
						{
							path: "investments",
							component: InvestmentsComponent,
							canActivate: [TokenGuard],
						},	
						{
							path: "investments-user",
							component: InvestmentsUserComponent,
							canActivate: [TokenGuard],
						},		
						{
							path: "transactions",
							component: TransactionsComponent,
							canActivate: [TokenGuard],
						},			
					],
				},
			],
			{ preloadingStrategy: PreloadAllModules, useHash: true }
		),
	],
	exports: [RouterModule],
	providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class AppRoutingModule {}
